export enum CarType {
  electric = 'electric',
  hybrid = 'hybrid',
}

export interface CarSpecification {
  carType: CarType | null;
  batteryCapacity: number | null;
}
